import React from 'react';

import { withCurrentUser } from '../../hocs/with-current-user';

export type VisibleFilters = {
  allFamilyGroup: boolean;
  allCompletedDate: boolean;
  jobStartDate: boolean;
  jobAssignee: boolean;
};

export const defaultVisibleFilters: VisibleFilters = {
  allFamilyGroup: false,
  allCompletedDate: false,
  jobStartDate: false,
  jobAssignee: true,
};

const VisibleFiltersContext = React.createContext<
  [VisibleFilters, (s: React.SetStateAction<VisibleFilters>) => void]
>([defaultVisibleFilters, () => {}]);
VisibleFiltersContext.displayName = 'VisibleFiltersContext';

export const useVisibleFilters = () => React.useContext(VisibleFiltersContext);

export const VisibleFiltersProvider = withCurrentUser(
  ({ currentUser, children }) => {
    const [visibleFilters, setVisibleFilters] = React.useState<VisibleFilters>(
      () => {
        const userId = currentUser.cloudId;
        const s = userId && localStorage.getItem(`visiblefilters|${userId}`);
        const result = s
          ? (JSON.parse(s) as VisibleFilters)
          : defaultVisibleFilters;

        // do the spread thing so that we get the properties in the correct order, and any defaults
        // then, lay whatever came out of the parsed value (or the default if we've fallen back to that) over the top
        // in this case, we don't care about order
        return {
          ...defaultVisibleFilters,
          ...result,
        };
      }
    );
    React.useEffect(() => {
      const userId = currentUser.cloudId;
      if (userId)
        localStorage.setItem(
          `visiblefilters|${userId}`,
          JSON.stringify(visibleFilters)
        );
    }, [currentUser, visibleFilters]);

    return (
      <VisibleFiltersContext.Provider
        value={[visibleFilters, setVisibleFilters]}
      >
        {children}
      </VisibleFiltersContext.Provider>
    );
  }
);

VisibleFiltersProvider.displayName = 'VisibleFiltersProvider';
